import React, { useState, useEffect } from 'react';
import RewardStyles from '../../../assets/css/newStyling.module.css';
import junaid_jamshed from '../../../assets/images/Logo_jj.png'
import cross_stitch from '../../../assets/images/Logo_cross_stitch.png'
import breakout from '../../../assets/images/Logo_breakout.png'
import alkaram from '../../../assets/images/Logo_alkaram.png'
import servis from '../../../assets/images/Logo_Servis.png'
import nandos from '../../../assets/images/Logo_nandos.png'
import StreetPizza from '../../../assets/images/Logo_14thStreet.png'
import RedeemModal from '../../../assets/components/modal/RedeemModal'
import PFChangs from '../../../assets/images/Logo_pfChangs.png'
import EGiftCard from '../../../assets/images/Logo_egiftcard.png'
//import EGiftCard from '../../../assets/images/Logo_egiftcard_white.png'
import Mocca from '../../../assets/images/Logo_mocca.png'
import Xiaomi from '../../../assets/images/Logo_xiaomi.png'
import Audionic from '../../../assets/images/Logo_audionic.png'
import Dany from '../../../assets/images/Logo_dany.png'
import SecureLS from 'secure-ls';
import { create_reward_request } from '../../../actions/rewards_actions'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert'
import { Button } from "reactstrap";
import pointsBadge from '../../../assets/images/medal.png'
import { BACK_SERVER_URL } from '../../../config/server';
import axios from 'axios'


const RewardCards = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);
    const [totalPoints, setTotalPoints] = useState(0);
    const [profileCompleted, set_profileCompleted] = useState(false)
    const [two_months_criteria_fulfilled, set_two_months_criteria_fulfilled] = useState(false)
    const ls = new SecureLS()
    const dispatch = useDispatch()
    const user = ls.get('accessUser').user._id
    //const totalPoints = ls.get('accessUser').user.logs.pointsEarned // get this through an api call instead of local storage

    const handleButtonClick = (card) => {
        setSelectedCard(card);
        setIsModalOpen(true);
    };

    // useEffect(() => {
    //     axios.get(`${BACK_SERVER_URL}api/users/me`)
    //         .then((response) => {
    //             //console.log('User:', response.data)
    //             setTotalPoints(response.data.content.logs.pointsEarned)
    //             set_profileCompleted(response.data.content.profileCompleted)
    //         })
    // }, [])

    useEffect(() => {
        axios.get(`${BACK_SERVER_URL}api/users/get-details-for-rewards`)
            .then((response) => {
                
                //setAllowReward(response.data.content.two_months_criteria_fulfilled)
                setTotalPoints(response.data.content.total_points)
                set_profileCompleted(response.data.content.profile_completed)
                set_two_months_criteria_fulfilled(response.data.content.two_months_criteria_fulfilled)
            })
    }, [])


    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleRedeem = (selectedOption) => {



        // user is eligible for a reward request in everyway
        if (selectedCard && selectedOption && profileCompleted && two_months_criteria_fulfilled.two_months_criteria && (two_months_criteria_fulfilled.two_months_criteria_type === 'old_account' || two_months_criteria_fulfilled.two_months_criteria_type === 'old_reward')) {
            //console.log('Redeeming:', selectedCard);
            let data = {
                status: 'Scheduled',
                redeemPoints: selectedOption.value,
                rewardCash: selectedOption.label,
                brand: selectedCard.title
            }
            //console.log('finalized data ->',data)


            dispatch(create_reward_request(data, user))
                .then((response) => {
                   
                    toggleModal();
                    if (response.payload.message === 'Reward request created successfully') {


                        Swal({
                            title: "Request Submitted!",
                            text: "Your redemption request has been successfully generated. You will be contacted through email soon.",
                            icon: 'success'
                        });

                    }
                    else if (response.payload.message === 'There are rewards with status Scheduled or Processing') {

                        Swal({
                            // title: "",
                            text: "Your previous request's are still being processed. Please wait until it is completed before submitting a new request.",
                            icon: 'info'
                        });
                    }


                })
                .catch((error) => {
                   
                })
        } 
        else if(selectedCard && selectedOption && two_months_criteria_fulfilled.two_months_criteria_type === 'pending_rewards') {
            Swal({
               
                text: "Your previous request's are still being processed. Please wait until it is completed before submitting a new request.",
                icon: 'info'
            });
        }
       
        else if (selectedCard && selectedOption && profileCompleted === false ) {
            Swal({
                title: 'Incomplete Profile',
                text: "Please complete your profile to 100% to claim your reward!",
                icon: 'error'
            });
        }
        else if (selectedCard && selectedOption && profileCompleted === true && two_months_criteria_fulfilled.two_months_criteria === false && two_months_criteria_fulfilled.two_months_criteria_type === 'new_reward') {
            Swal({
                text: "You’ve already redeemed a reward recently. Rewards can only be claimed once every 2 months. Please try again after the cooldown period",
                icon: 'info'
            });
        }
        else if (selectedCard && selectedOption && profileCompleted === true && two_months_criteria_fulfilled.two_months_criteria === false && two_months_criteria_fulfilled.two_months_criteria_type === 'new_account') {
            Swal({
                text: "You’ve created your account recently. Rewards can only be claimed once every 2 months. Please try again after the cooldown period",
                icon: 'info'
            });
        }
        else {
            Swal({

                text: "Something went wrong. Please contact support!",
                icon: 'error'
            });
        }
    };

    const cards = [
        { id: 1, title: 'J. Gift Card', price: 'PKR 1,000', points: 1000, image: `${junaid_jamshed}` },
        { id: 2, title: 'Cross Stitch Gift Card', price: 'PKR 1,000', points: 1000, image: `${cross_stitch}` },
        { id: 3, title: 'Breakout Gift Card', price: 'PKR 1,000', points: 1000, image: `${breakout}` },
        { id: 4, title: 'Alkaram Gift Card', price: 'PKR 1,000', points: 1000, image: `${alkaram}` },
        { id: 5, title: 'Servis Gift Card', price: 'PKR 1,000', points: 1000, image: `${servis}` },
        { id: 6, title: 'Nandos Gift Card', price: 'PKR 1,000', points: 1000, image: `${nandos}` },
        //{ id: 7, title: '14th Street Pizza Gift Card', price: 'PKR 1,000', points: 1000, image: `${StreetPizza}` },
        //{ id: 8, title: 'PF Changs Gift Card', price: 'PKR 1,000', points: 1000, image: `${PFChangs}` },
        { id: 7, title: 'Universal E Gift Card', price: 'PKR 1,000', points: 1000, image: `${EGiftCard}` },
        { id: 8, title: 'Mocca Gift Card', price: 'PKR 1,000', points: 1000, image: `${Mocca}` },
        { id: 9, title: 'Xiamoi Gift Card', price: 'PKR 1,000', points: 1000, image: `${Xiaomi}` },
        { id: 10, title: 'Audionic Gift Card', price: 'PKR 1,000', points: 1000, image: `${Audionic}` },
        { id: 11, title: 'Dany Gift Card', price: 'PKR 1,000', points: 1000, image: `${Dany}` },
        { id: 12, title: 'Foodpanda Gift Card', price: 'PKR 250', points: 250, image: `${EGiftCard}` },

    ];

    return (

        <div className={RewardStyles.gift_card_container}>
            {cards.map((card) => (
                <div key={card.id} className={RewardStyles.gift_card}>
                    <img src={`${card.image}`} alt={card.title} className={RewardStyles.gift_card_image} />
                    <div className='p-3'>
                        <h3 className={RewardStyles.gift_card_title}>{card.title}</h3>

                        <div className='d-flex justify-content-center align-items-center'>
                            <p className={RewardStyles.gift_card_points}>Minimum {card.points}</p>  <img src={pointsBadge} alt='image' className={`${RewardStyles.reward_badge}`}></img>
                        </div>
                        {totalPoints >= card.points &&
                            <Button className={"btn-hover-shine mt-4"} style={{ cursor: 'pointer', backgroundColor: '#0069AB', color: 'white', border: 'none' }} onClick={() => handleButtonClick(card)}>Redeem Reward</Button>
                        }

                    </div>
                </div>
            ))}

            {isModalOpen && (
                <RedeemModal
                    isModalOpen={isModalOpen}
                    setModal={toggleModal}
                    brand={selectedCard.title}
                    brandMinPoints={selectedCard.points}
                    onClick={handleRedeem}
                    totalPoints={totalPoints}
                    variations={true}
                />
            )}
        </div>


    );
};

export default RewardCards;
